(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// =========
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.trans = this.dataset.trans;
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
    this.onScroll();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
      this.header.classList.remove('scrolled-past-header');
      if(this.trans != 'false') this.classList.add('transparent_header');
      document.body.classList.remove('sticky-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upload"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const dropZone = document.getElementById('drop-zone');
  const fileInput = document.getElementById('custom-image-input');
  const previewImg = document.getElementById('preview-img');
  const placeholder = document.getElementById('image-placeholder');
  const imageUrlInput = document.getElementById('image-url-input');
  const gridImages = document.querySelectorAll('.grid-image');
  const confirmBtn = document.getElementById('confirm-btn');
  const generateBtn = document.getElementById('generate-btn');
  const privacyCheckbox = document.getElementById('privacy-checkbox');
  const privacyLink = document.getElementById('privacy-link');
  const countDisplay = document.getElementById('count-display');

  const removeBtn = document.getElementById('remove-image-btn');

  const baseUrl = `https://api-shopify.minicodelab.com/api`

  let uploadCount = 2;
  let selectedImageUrl = '';

  // ---- 按钮控制 ----
  function enableButton() {
    if (!uploadedImageUrl || !privacyCheckbox.checked) return;
    generateBtn.disabled = false;
    generateBtn.classList.remove("disabled");
  }

  function disableButton() {
    generateBtn.disabled = true;
    generateBtn.classList.add("disabled");
  }
  
  // 初始禁用按钮
  function enableConfirm() {
    confirmBtn.disabled = false;
    confirmBtn.classList.remove('disabled');
  }
  
  function disableConfirm() {
    confirmBtn.disabled = true;
    confirmBtn.classList.add('disabled');
  }
  function updateCountDisplay() {
    countDisplay.textContent = uploadCount;
    
    // 根据剩余次数改变颜色
    if (uploadCount <= 0) {
      countDisplay.style.color = '#ff4444';
    } else if (uploadCount === 1) {
      countDisplay.style.color = '#ff9900';
    } else {
      countDisplay.style.color = '#00a000';
    }
  }

  // 错误弹窗显示函数
  function openErrorModal(errorMessage) {
    const errorModal = document.getElementById('error-message-modal');
    const errorMessageText = document.getElementById('error-message-text');
    const errorMessageTitle = document.getElementById('error-message-title');

    errorMessageTitle.textContent = '❌ An error occurred'; // 英文提示
    errorMessageText.textContent = errorMessage;
    errorModal.style.display = 'flex';

    // 关闭弹窗按钮
    const closeBtn = document.getElementById('close-error-modal');
    closeBtn.addEventListener('click', () => {
      errorModal.style.display = 'none';
    });

    // 点击背景时也关闭弹窗
    errorModal.addEventListener('click', (e) => {
      if (e.target === errorModal) {
        errorModal.style.display = 'none';
      }
    });
  }
  // 页面加载时禁用
  disableConfirm();
  disableButton();

  // ---- 隐私协议链接点击事件 ----
  privacyLink.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById("privacy-modal").style.display = "flex";
  });

  // ---- 隐私协议弹窗事件 ----
  document.getElementById("agree-privacy").onclick = function() {
    localStorage.setItem("privacy_agreed", "yes");
    privacyCheckbox.checked = true;
    document.getElementById("privacy-modal").style.display = "none";
    checkPrivacyAgreement();
  };

  document.getElementById("decline-privacy").onclick = function() {
    document.getElementById("privacy-modal").style.display = "none";
    privacyCheckbox.checked = false;
    checkPrivacyAgreement();
  };

  // ---- 复选框变化事件 ----
  privacyCheckbox.addEventListener('change', checkPrivacyAgreement);

  function checkPrivacyAgreement() {
     if (privacyCheckbox.checked) {
      enableButton();
    } else {
      disableButton();
    }
  }

  // ---- 拖拽上传逻辑 ----
  dropZone.addEventListener('click', () => fileInput.click());

  dropZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropZone.classList.add('drag-active');
  });

  dropZone.addEventListener('dragleave', () => {
    dropZone.classList.remove('drag-active');
  });

  dropZone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropZone.classList.remove('drag-active');
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  });

  fileInput.addEventListener('change', () => {
    const file = fileInput.files[0];
    if (file) handleFile(file);
  });

  function handleFile(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      previewImg.src = e.target.result;
      previewImg.style.display = 'block';
      placeholder.style.display = 'none';
      // 有图片时检查隐私协议
      if (privacyCheckbox.checked) {
        enableButton();
      }
    };
    reader.readAsDataURL(file);
    uploadImage()
    removeBtn.style.display = 'block';
  }

// 点击 X 删除图片
  removeBtn.addEventListener('click', () => {
    // 清空预览图
    previewImg.src = '';
    previewImg.style.display = 'none';

    // 显示占位 HTML
    placeholder.innerHTML = `
      Drag & drop an image here, or 
      <span id="select-file" style="color:#007bff; cursor:pointer; text-decoration:underline;">click to select</span>
    `;
    placeholder.style.display = 'block';

    // 隐藏删除按钮
    removeBtn.style.display = 'none';

    // 清空上传 URL
    uploadedImageUrl = null;

    // 重新检查按钮状态
    checkPrivacyAgreement();

    // 重新绑定点击事件给新生成的 select-file
    document.getElementById('select-file').addEventListener('click', () => fileInput.click());
  });


    /** 
   * https://son-uriniferous-kurt.ngrok-free.dev
   * https://api-shopify.minicodelab.com/api/oss
  */

  let uploadedImageUrl = null;

async function uploadImage() {
  if (!fileInput.files.length) {
    alert('Please select or drag in an image first.');
    return;
  }
  if (uploadCount <= 0) {
    alert('The number of uploads has been exhausted.');
    return;
  }

  const file = fileInput.files[0];
  const formData = new FormData();
  formData.append('file', file);

  placeholder.textContent = 'Uploading...';
  placeholder.style.display = 'block';
  previewImg.style.display = 'none';

  // 显示进度弹窗
  const modal = document.getElementById('upload-modal');
  const progressText = document.getElementById('upload-progress-text');
  const progressBar = document.getElementById('upload-progress-bar');
  modal.style.display = 'flex';
  progressText.textContent = '0%';
  progressBar.style.width = '0%';

  try {
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${baseUrl}/oss`);

      // 上传进度
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = Math.min(Math.round((e.loaded / e.total) * 100), 95);
          progressText.textContent = `${percent}%`;
          progressBar.style.width = percent + '%';
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const data = JSON.parse(xhr.responseText);
          if (!data?.data?.url) return reject(new Error('Upload failed'));
          imageUrlInput.value = data.data.url;
          previewImg.src = data.data.url;
          previewImg.style.display = 'block';
          placeholder.style.display = 'none';
          console.log('图片上传完毕');
          uploadedImageUrl = data.data.url;
          enableButton()
          resolve(data.data.url);
        } else {
          reject(new Error('Upload failed'));
        }
      };

      xhr.onerror = () => reject(new Error('Upload error'));
      xhr.send(formData);
    });
  } catch (err) {
    console.error(err);
    placeholder.textContent = '❌ Upload failed, please try again.';
  } finally {
    modal.style.display = 'none';
  }
}


  const taskModal = document.getElementById('task-status-modal');
  const taskStatusText = document.getElementById('task-status-text');
  const taskModalCloseBtn = document.getElementById('task-status-close-btn');
  const spinner = document.getElementById('spinner');


function openTaskModal() {
  taskModal.style.display = 'flex';
  spinner.style.visibility = 'visible';
}

function closeTaskModal() {
  taskModal.style.display = 'none';
}

function updateTaskStatus(text, imageUrl) {
  if (imageUrl) {
    const img = document.createElement('img');
    img.src = imageUrl;
    img.style.width = '60%';
    img.style.marginTop = '10px';
  }
}

  taskModalCloseBtn.addEventListener('click', closeTaskModal);


  // 提交生成任务
  async function submitTask(imagePath, taskId) {
    if (uploadCount <= 0) {
      throw new Error('Sorry, the maximum number of generations has been reached.');
    }
      // 提取出请求体的内容
    const requestBody = {
      imagePath,
      taskId: (uploadCount===1)? 1 : null, // 这里假设 `is_task_id` 是已经定义的
    };
    openTaskModal();
    const resp = await fetch(`${baseUrl}/image-processor/generate-image`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody) // ✅ 必须 stringify
    });
    const data = await resp.json();
    if (!resp.ok) throw new Error(data?.message || 'Submit task failed');

    if (!data?.data?.id) throw new Error('No taskRequestId returned');
    uploadCount--; 
    updateCountDisplay()
    return data.data.id;
  }


  // 轮询任务状态
  async function pollTaskStatus(taskRequestId, interval = 3000) {    
    let startTime = Date.now();
    let polling = true;
    let finalUrl = null;

    while (polling) {

      const resp = await fetch(`${baseUrl}/image-processor/task-status?taskRequestId=${taskRequestId}`);
      const result = await resp.json();

      if (!resp.ok || !result?.data?.data) {
        updateTaskStatus('❌ Error fetching task status...');
        break;
      }

      const data = result.data.data;

      // === 新增：解析更多字段 ===
      const status        = data.status;
      const queuePosition = (data.queuePosition ?? -1) + 1;
      const taskId        = data.taskId;
      const elapsed       = ((Date.now() - startTime) / 1000).toFixed(1);

      // === 更新任务状态文字（主） ===
      let statusText = '';
      if (status === 'QUEUING') {
        statusText = `⏳ Queuing... Waiting in line`;
      } else if (status === 'PROCESSING') {
        statusText = `🛠 Generating image...`;
      } else if (status === 'SUCCESS') {
        statusText = `✅ Generation Success`;
      } else if (status === 'FAILED') {
        statusText = `❌ Generation Failed`;
      }

      updateTaskStatus(statusText);
      // === 更新扩展信息 ===
      const extraInfoBox = document.getElementById("task-extra-info");

      if(status === "SUCCESS"){
        // 成功时隐藏扩展信息
        extraInfoBox.style.display = "none";
        taskModal.style.display = 'none';  // 隐藏弹窗
      }

      // === 生成成功 ===
      if (status === 'SUCCESS') {
        console.log(data)
        finalUrl = data?.urls?.[0];
                console.log(finalUrl)

        style = data?.style;
        updateTaskStatus("✅ Generation Success", finalUrl);
        polling = false;
      }

      // === 失败 ===
      if (status === 'FAILED') {
        updateTaskStatus("❌ Generation Failed");
        polling = false;
      }

      if (polling) {
        await new Promise(res => setTimeout(res, interval));
      }

    }

    return {finalUrl, style};
  }

  // 将生成图片放入九宫格
  function placeImageInGrid(taskRes){
    const { finalUrl, style } = taskRes
    const newImageUrl = finalUrl
      // 检查 right-section 是否被隐藏，若隐藏则取消隐藏
    const rightSection = document.querySelector('.right-section');
    if (rightSection ) {
      rightSection.style.display = 'block'; // 取消隐藏
    }   
    if (!gridContainer) return;

    const gridItems = Array.from(gridContainer.querySelectorAll('.grid-item'));
    const newImg = document.createElement('img');
    newImg.src = newImageUrl;
    newImg.alt = 'Generated Image';
    newImg.className = 'grid-image';
    newImg.dataset.url = newImageUrl;
    newImg.style.width = '100%';
    newImg.style.height = '100%';
    newImg.style.objectFit = 'contain';

    // 创建风格标签
    const styleTag = document.createElement('span');
    styleTag.className = 'style-tag';
    styleTag.textContent = style || 'Default Style';  // 如果没有提供style，使用默认风格

    // 创建风格标签容器
    const styleTagsContainer = document.createElement('div');
    styleTagsContainer.className = 'style-tags';
    styleTagsContainer.appendChild(styleTag);

    let placed = false;
    for (const item of gridItems){
      const imgInside = item.querySelector('img');
      if(!imgInside || /No image/i.test(imgInside.alt || '')){
        item.innerHTML = '';
        item.appendChild(styleTagsContainer);  // 添加风格标签
        item.appendChild(newImg.cloneNode(true));
        placed = true;
        break;
      }
    }

    if(!placed){
      window._shopifyGridIndex = (window._shopifyGridIndex || 0) % gridItems.length;
      const target = gridItems[window._shopifyGridIndex];
      target.innerHTML = '';
      target.appendChild(styleTagsContainer);  // 添加风格标签
      target.appendChild(newImg.cloneNode(true));
      window._shopifyGridIndex = (window._shopifyGridIndex + 1) % gridItems.length;
    }
  }

  // === 生成图片按钮逻辑（稳健版） ===
// ===== 生成按钮点击事件 =====
  generateBtn.addEventListener('click', async () => {
    try {
      if(!privacyCheckbox.checked) { alert('Please agree to Privacy Agreement'); return; }
      if (!uploadedImageUrl) {
        alert('Please upload an image first.');
        return;
      }
      generateBtn.disabled = true;
      generateBtn.textContent = 'Generating...';

      // 提交任务
      const taskRequestId = await submitTask(uploadedImageUrl);
      if (!taskRequestId) {
        throw new Error('Image generation failed, please try again later');
      }
      // 轮询状态
      const finalUrl = await pollTaskStatus(taskRequestId);

      // 放入九宫格
      if(finalUrl) placeImageInGrid(finalUrl);

    } catch(err) {
      console.error(err);
      closeTaskModal();
    // 错误信息提示
      const errorMessageContainer = document.getElementById('error-message-container');
      openErrorModal(`❌ Error: ${err.message || 'Unknown error'}, please try again later.`);

    } finally {
      generateBtn.disabled = false;
      generateBtn.textContent = 'Generate';
    }
  });

  // === 图片点击选择逻辑（使用事件委托，避免需要为每个 img 单独绑定） ===
  const gridContainer = document.querySelector('.grid-container');

  if (gridContainer) {
    // delegation: single handler for all current + future .grid-image elements
    gridContainer.addEventListener('click', function (evt) {
      const clicked = evt.target;
      if (!clicked) return;
      
      // 修改点：查找点击的 .grid-item 容器（而不是 .grid-image）
      const gridItem = clicked.closest('.grid-item');
      if (!gridItem) return;
      
      // remove selected class from all items, add to current item
      document.querySelectorAll('.grid-item').forEach(i => i.classList.remove('selected'));
      gridItem.classList.add('selected');
      
      // store selected url - 从容器内的图片获取
      const gridImage = gridItem.querySelector('.grid-image');
      selectedImageUrl = gridImage?.dataset.url || gridImage?.src || '';
      if (selectedImageUrl && selectedImageUrl != 'https://shopify-data.oss-cn-hangzhou.aliyuncs.com/3d-products/ima-test-2dc3462b-faa3-4b8d-bd88-aca5889a497f.png') {
        enableConfirm();
      } else {
        disableConfirm();
      }
    });

    // Optional: re-run binding after dynamic updates (we use event 'gridUpdated' above)
    gridContainer.addEventListener('gridUpdated', function (e) {
      console.log('gridUpdated event fired, new url:', e?.detail?.url);
      // nothing required here because event delegation handles clicks
    });
  }

  // 获取弹窗元素
  const imageConfirmModal = document.getElementById('image-confirm-modal');
  const confirmModalImg = document.getElementById('confirm-modal-img');
  const modalConfirmBtn = document.getElementById('confirm-selection-btn');
  const modalCancelBtn = document.getElementById('cancel-selection-btn');

// 确认按钮点击事件
  confirmBtn.addEventListener('click', () => {

    // 判断是否选中图片
    if (!selectedImageUrl) {
      alert('Please select an image first.');
      return;
    }

    // 在弹窗中显示当前选中的图片
    confirmModalImg.src = selectedImageUrl;
    
    // 弹窗展示
    imageConfirmModal.style.display = 'flex';

    // 确认按钮事件
    modalConfirmBtn.addEventListener('click', () => {
      // 保存选中的图片URL
      window.selectedImageUrl = selectedImageUrl;
      localStorage.setItem('selectedImageUrl', selectedImageUrl);

      // 关闭弹窗
      imageConfirmModal.style.display = 'none';

      // 页面滚动到下一个区域（可选）
      const targetSection = document.getElementById('shopify-section-template--20977428234452__main');
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // 取消按钮事件
    modalCancelBtn.addEventListener('click', () => {
      // 关闭弹窗
      imageConfirmModal.style.display = 'none';
    });
  });

  // 如果点击背景区域，也关闭弹窗
  imageConfirmModal.addEventListener('click', (e) => {
    if (e.target === imageConfirmModal) {
      imageConfirmModal.style.display = 'none';
    }
  });

});

  } catch(e) { console.error(e); }
})();
})();
